import { notification } from 'antd';
import apiService from '../utils/apiInterceptor';
import eventBus from '../utils/eventBus';

const cartService = {
  // Add better error handling and return the response consistently
addToCart: async (pid) => {
  try {
     
    const response = await apiService.post(`/default-cart`, {
      property_id: pid
    });
    
    if (response && response.status) {
      eventBus.emit('cart:updated', response.cart || {});
      
      notification.success({
        message: 'Added to Cart',
        description: response.message || 'Item added to cart successfully.',
      });
      
      return response;
    } else {
      throw new Error(response?.message || 'Failed to add item to cart');
    }
  } catch (error) {
    console.error('Error adding to cart:', error);
    notification.error({
      message: 'Cart Error',
      description: error.message || 'Could not add item to cart.',
    });
    
    return false;
  } finally {
   }
},
convertToCleaning: async (propertyId, hours = 1) => {
  try {
    const response = await apiService.post('/cart/convert-to-cleaning', {
      property_id: propertyId,
      hours,
    });
    if (response?.status) {
      notification.success({
        message: 'Converted to Collection Only',
        description: 'All items were cleared and Collection Only added.',
      });
      if (response.cart) {
        eventBus.emit('cart:updated', response.cart);
      }
    } else {
      notification.error({
        message: 'Cannot convert',
        description: response?.message || 'Server refused to convert this property to a cleaning order.',
      });
    }
    return response;
  } catch (error) {
    console.error('Error converting to cleaning:', error);
    notification.error({
      message: 'Error',
      description: 'Failed to convert to cleaning.',
    });
    throw error;
  }
},
removeFromCart: async (id, pid) => {
  try {
     
    const response = await apiService.get(`/remove-cart/${id}/${pid}`);
    
    if (response && response.status) {
      // Emit cart updated event
      eventBus.emit('cart:updated', response.cart || {});
      
      notification.success({
        message: 'Removed from Cart',
        description: response.message || 'Item removed from cart successfully.',
      });
      
      return response;
    } else {
      throw new Error(response?.message || 'Failed to remove item from cart');
    }
  } catch (error) {
    console.error('Error removing from cart:', error);
    notification.error({
      message: 'Cart Error',
      description: error.message || 'Could not remove item from cart.',
    });
    
    return false;
  } finally {
   }
},
  
 getCart: async () => {
  try {
    const response = await apiService.get('/get-cart');
    
    // Emit cart updated event
    if (response && response.cart) {
      eventBus.emit('cart:updated', response.cart);
    }
    
    return response;
  } catch (error) {
    console.error('Error getting cart:', error);
    throw error;
  }
},
};

export default cartService;
